import React, { useState, useEffect } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import '../../styles/ContainerTab.css';

const ContainerTab = ({ data, masterData, onChange }) => {
    const [containers, setContainers] = useState(data || []);
    const containerTypes = masterData.containerTypes || [];

    useEffect(() => {
        // Ensure we always have at least one row
        if (!data || data.length === 0) {
            const defaultRow = {
                JContainerDetailID: null,
                ContainerTypeID: null,
                ContainerNo: '',
                SealNo: '',
                Description: ''
            };
            setContainers([defaultRow]);
            onChange([defaultRow]);
        } else {
            setContainers(data);
        }
    }, [data]);

    useEffect(() => {
        console.log('ContainerTab - Container Types:', containerTypes.length);
    }, [containerTypes]);

    const addNewRow = () => {
        const newRow = {
            JContainerDetailID: null,
            ContainerTypeID: null,
            ContainerNo: '',
            SealNo: '',
            Description: ''
        };
        const updated = [...containers, newRow];
        setContainers(updated);
        onChange(updated);
    };

    const deleteRow = (index) => {
        if (containers.length === 1) {
            alert('Cannot delete the last row. At least one container entry is required.');
            return;
        }
        
        if (window.confirm('Delete this container?')) {
            const updated = containers.filter((_, i) => i !== index);
            setContainers(updated);
            onChange(updated);
        }
    };

    const updateRow = (index, field, value) => {
        const updated = [...containers];
        updated[index][field] = value;
        setContainers(updated);
        onChange(updated);
    };

    const getContainerTypeName = (id) => {
        const type = containerTypes.find(ct => ct.id === id);
        return type ? type.name : '';
    };

    return (
        <div className="container-tab">
            <div className="tab-header">
                <h3>Container Details</h3>
                <button className="btn btn-primary btn-sm" onClick={addNewRow}>
                    <Plus size={16} />
                    Add Container
                </button>
            </div>

            {containerTypes.length === 0 && (
                <div className="warning-message">
                    <strong>Warning:</strong> No container types available. 
                    Please add container types in the master data first.
                </div>
            )}

            <div className="table-wrapper">
                <table className="container-table">
                    <thead>
                        <tr>
                            <th style={{width: '50px'}}>#</th>
                            <th style={{width: '200px'}}>Container Type *</th>
                            <th style={{width: '180px'}}>Container No</th>
                            <th style={{width: '150px'}}>Seal No</th>
                            <th style={{minWidth: '250px'}}>Description</th>
                            <th style={{width: '60px'}}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {containers.length === 0 ? (
                            <tr>
                                <td colSpan="6" className="empty-message">
                                    No containers added. Click "Add Container" to begin.
                                </td>
                            </tr>
                        ) : (
                            containers.map((container, index) => (
                                <tr key={index}>
                                    <td className="row-number">{index + 1}</td>
                                    <td>
                                        <select
                                            value={container.ContainerTypeID || ''}
                                            onChange={(e) => updateRow(index, 'ContainerTypeID', parseInt(e.target.value) || null)}
                                            className="grid-select"
                                        >
                                            <option value="">Select Type</option>
                                            {containerTypes.map(ct => (
                                                <option key={ct.id} value={ct.id}>
                                                    {ct.name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            value={container.ContainerNo || ''}
                                            onChange={(e) => updateRow(index, 'ContainerNo', e.target.value)}
                                            className="grid-input"
                                            placeholder="Container number"
                                            maxLength="20"
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            value={container.SealNo || ''}
                                            onChange={(e) => updateRow(index, 'SealNo', e.target.value)}
                                            className="grid-input"
                                            placeholder="Seal number"
                                            maxLength="20"
                                        />
                                    </td>
                                    <td>
                                        <textarea
                                            value={container.Description || ''}
                                            onChange={(e) => updateRow(index, 'Description', e.target.value)}
                                            className="grid-textarea"
                                            placeholder="Additional details"
                                            rows="2"
                                        />
                                    </td>
                                    <td>
                                        <button
                                            className="btn-icon btn-danger"
                                            onClick={() => deleteRow(index)}
                                            title="Delete"
                                            disabled={containers.length === 1}
                                        >
                                            <Trash2 size={16} />
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            <div className="container-summary">
                <div className="summary-info">
                    <strong>Total Containers:</strong> {containers.length}
                </div>
                <div className="container-types-breakdown">
                    <strong>By Type:</strong>
                    {containerTypes.map(ct => {
                        const count = containers.filter(c => c.ContainerTypeID === ct.id).length;
                        if (count > 0) {
                            return (
                                <span key={ct.id} className="type-badge">
                                    {ct.name}: {count}
                                </span>
                            );
                        }
                        return null;
                    })}
                </div>
            </div>
        </div>
    );
};

export default ContainerTab;